import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axios/index';

const initialState = {
	refunds: {
		loading: false,
		refundList: [],
		total: 0,
	},
};

export const getAllRefunds = createAsyncThunk('Refunds/getAllRefunds', async ({ page = 0, size = 10, search = '', sortBy = 'created', sortDirection = 'DESC' } = {}) => {
	try {
		const params = `page=${page}&size=${size}&sortBy=${sortBy}&sortDirection=${sortDirection}${search ? `&search=${encodeURIComponent(search)}` : ''}`;
		const response = await axiosInstance.get(`booking-refund?${params}`);
		return { list: response.data.content, total: response.data.totalElements };
	} catch (error) {
		console.log(error);
		const customError = {
			name: 'Error login',
			message: error.response.data.message,
		};
		throw customError;
	}
});

export const refundSlice = createSlice({
	name: 'Refunds',
	initialState,
	reducers: {},
	extraReducers: {
		[getAllRefunds.pending]: (state) => {
			state.refunds.loading = true;
		},
		[getAllRefunds.fulfilled]: (state, action) => {
			state.refunds.loading = false;
			state.refunds.refundList = action.payload.list;
			state.refunds.total = action.payload.total;
		},
		[getAllRefunds.rejected]: (state) => {
			state.refunds.loading = false;
		},
	},
});

export default refundSlice.reducer;
